import type {
  CloudVnicDecision,
  PathLookupDecisionEvent,
} from '@ipfabric/utils';

/**
 * The decision payloads live in `@ipfabric/utils` next to `DecisionType`, so the
 * engine that emits them and this table share one definition. A subnet emits
 * only the shared routing member; everything else on its table is a security check or a drop.
 * A peering emits that same routing member and nothing else (NIM-25157), so the
 * union stays the vNIC's.
 */
export type CloudConstructDecisionEvent = PathLookupDecisionEvent &
  CloudVnicDecision;

export const isCloudConstructDecisionEvent = (
  event: PathLookupDecisionEvent,
): event is CloudConstructDecisionEvent => {
  switch (event.type) {
    case 'cloud route match':
    case 'cloud vnic ip forwarding':
    case 'cloud vnic workload handoff':
      return true;
    default:
      return false;
  }
};

export const isCloudSecurityCheckEvent = (
  event: PathLookupDecisionEvent,
): boolean =>
  event.securityType === 'cloud' &&
  (event.type === 'security check' || event.type === 'security check ignored');
